module.exports = "/images/arrow-down-icon.svg?42d6f6705a9094a1342e2d15665adbf0";